import React, {useContext, useState} from 'react';
import TextBox from '../../../ui/TextBox';
import Date from '../../../ui/Date';
import MultilineTextBox from "../../../ui/MultilineTextBox";
import { compareIso, nowDate } from '../../../dateUtils';
import _ from 'lodash';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../ApplicationContext';
import DocReportCard from '../../../uiControls/Docreportcard';
import InlineInputControlRow from '../../../ui/layout/InlineInputControlRow';
import CompanyLookupField from '../../../uiControls/lookup/CompanyLookupField';
import RadioButton from '../../../ui/RadioButton';
import InlineInputControlDoubleRow from '../../../ui/layout/InlineInputControlDoubleRow';
import Select from '../../../ui/Select';
import  { Time } from '../../../ui/DateTime';
import PrimaryButton from '../../../ui/PrimaryButton';
import { ReportSchHd } from '../../../fms.core/ReportSchHd';
import { ColumnSettings } from '../../../uiControls/SmartTable';
import IfmsModal from '../../../ui/IfmsModal';
import { TableColumn, TableSettings } from '../../../tableSettings';
import config from '../../../config';
import Spinner from '../../../ui/Spinner';
import Modal from 'react-modal';
import CheckBox from '../../../ui/CheckBox';
import EmailTemplateDropDown from '../../../uiControls/EmailTemplateDropDown';

function ReportSchedulingDetails({
  title,
  save,
  reportSch,
  onChange,
  isView,
  isEdit,
  cancel,
  settingColumn,
  setSettingColumn,
  defaultColumn,
}: {
  title: string,
  save: (x: boolean) => Promise<boolean>
  reportSch: ReportSchHd,
  onChange: (x: Partial<ReportSchHd>) => void,
  isView: boolean,
  isEdit: boolean,
  cancel: VoidFunction,
  settingColumn: TableSettings,
  setSettingColumn: (x: Partial<TableSettings>) => void,
  defaultColumn: TableColumn[],
}) {

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const [showColumnConfiguration, setShowColumnConfiguration] = useState(false);
  const [exportLoadingMessage, setExportLoadingMessage] = useState(false);

  const isStartDateEditable = !reportSch.startDate || compareIso(reportSch.startDate, nowDate()) >= 0;

    const ModalOverlayStyle:React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 999998
  };

  const ModalContentStyle:React.CSSProperties = {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10000
  };



  function saveColumnsSettings(newColumns: Array<TableColumn>) {
    // close popup
    if(isView) return;
    setShowColumnConfiguration(false);

    const settingsCopy = _.cloneDeep(settingColumn);
    settingsCopy.columns = newColumns;
    // //<pt250428>
    settingsCopy.isCustomized = checkIsCustomized(newColumns);

    onChange({isColumnChange: true});

    setSettingColumn(settingsCopy);
  }

  function checkIsCustomized(newColumns: TableColumn[]) {
     let colChanged = false;
     let seqChanged = newColumns.some((d, i) => d.accessor !== defaultColumn[i].accessor);
     if (!seqChanged) {
       for (let i = 0; i < newColumns.length; i++) {
         let c = defaultColumn.find(x => x.accessor === newColumns[i].accessor);
         if (!c) return;  // Nerver happen
         if (c.visible !== newColumns[i].visible) {
           colChanged = true;
           break;
         }
       };
     }
     return seqChanged || colChanged;
   }

  function sanitizeFileName(fileName: string) {
      return fileName
        ?.replaceAll(/\:/g, '-')                // 윈도우 파일시스템 제한 문자
        ?.replaceAll(/[/\\?%*|"<>+]/g, ' ')     // 윈도우 파일시스템 제한 문자 && 업로드 파일 URL 호출 시 특수문자가 포함되어 있을 경우 에러가 발생함("+" 문자 추가)
        ?.replaceAll(/\./g, ' ')                // 마침표를 공백으로            ???
        ?.replaceAll(/\#/g, ' ')                // #을 공백으로                ???
        ?.replaceAll(/\s+/g, ' ')               // 연속된 공백을 하나로
        ?.trim();                               // 앞뒤 공백 제거
  }

  async function exportToExcel() {

    if(!isView){
      const result = await save(true); //export 하기 전 save 먼저 실행
      if(!result) return;
    }

    setExportLoadingMessage(true);
    
    const userToken = appContext.user ? appContext.user.accessToken ?? '' : '';

    try {
      const response = await fetch(`${config.serverUrl}report/exportShipmentreport`, {
        method: 'POST',
        headers: {
          //'Authorization': `Bearer ${userToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: reportSch.id, jwt: userToken })
      });

      if(response.status === 204) {
          setExportLoadingMessage(false);
          await showGlobalOkDialog(<p>There is no Information!</p>);
          return;
      }

      const fileName = sanitizeFileName(reportSch.reportName);
      if (response.ok) {
        //const contentType = response.headers.get('content-type');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = (fileName+".xlsx").replaceAll(' ', '-');
        a.click();
      } else {
        console.error('error', response.status);
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      setExportLoadingMessage(false);
    }
  }

  async function validStartDate(){
      if (!reportSch.startDate) return;
      const today = nowDate();
      let warningMsg = "";
      if(compareIso(reportSch.startDate, today) < 0) {
         warningMsg ="Invalid Start Date, Start Date should not be earlier than today.";
      }
      if(warningMsg){
        await showGlobalOkDialog(warningMsg);
        onChange({startDate: reportSch.oldStartDate});
      }
      else onChange({oldStartDate: reportSch.startDate});
  }

  async function validEndDate(){
    if(!reportSch.endDate) return;
    if(!reportSch.startDate) return;
    if(compareIso(reportSch.endDate, reportSch.oldEndDate??'') === 0) return;
    let warningMsg = "";
    const today = nowDate();
    if(compareIso(reportSch.endDate, today) < 0) {
        warningMsg ="Invalid End Date, End Date should not be earlier than today.";
    }
    else if (compareIso(reportSch.startDate, reportSch.endDate) > 0){
      warningMsg = "Invalid End Date, End Date should not be earlier than Start Date.";
    }
    if(warningMsg){
      await showGlobalOkDialog(warningMsg);
      onChange({endDate: reportSch.oldEndDate});
    }
    else onChange({oldEndDate: reportSch.endDate});
  }

  return (
    <DocReportCard
      title={title}
      width='690px'
      footerButtons={
        !isView ? 
          appContext.user?.isSuntekAdmin ? //cms 계정으로 스케쥴러 생성 불가
          [
            { text: 'Preview', onClick: exportToExcel, disabled: !(isEdit && isView) },
            { text: 'CANCEL', onClick: cancel },
          ] 
          :
          [
            { text: 'Preview', onClick: exportToExcel },
            { text: 'Save', onClick: () => save(false)},
            { text: 'CANCEL', onClick: cancel },
          ] 
        :
        [
          { text: 'Preview', onClick: exportToExcel },
          { text: 'CANCEL', onClick: cancel },
        ]
    }
    >
      <div>
        <div>
          <InlineInputControlRow label='Report Name' mode='small' smallMargin bold>
            <div style={{width: '360px'}}>
              <TextBox name="reportSch-input-reportName" id="report-Name" disabled={isView} value={reportSch.reportName ?? ''} 
                onChange={ e => onChange({reportName: e.target.value})}
                maxLength={200}
                />
            </div>
          </InlineInputControlRow>
          <InlineInputControlRow>&nbsp;</InlineInputControlRow>
          <InlineInputControlRow label='Customer' mode='small' smallMargin bold>
            <div style={{width: '360px'}}>
              <CompanyLookupField lookupId='customer' initialValue={reportSch.customerName} disabled={isView}
                onTextChange={shortName => onChange({customerId: 0, customerName: shortName})}
                onSelect={company => onChange({customerId: company.id, customerName: company.shortName??''})}
              />
            </div>
          </InlineInputControlRow>
          <InlineInputControlRow>&nbsp;</InlineInputControlRow>
          <InlineInputControlRow label='From' mode='small' smallMargin bold>
            <div style={{width: '360px'}}>
              <TextBox name="reportSch-input-From" id="From" disabled value={appContext.user?.email} 
                />
            </div>
          </InlineInputControlRow>
          <InlineInputControlRow>&nbsp;</InlineInputControlRow>
          <InlineInputControlRow label='Recipient Emails' mode='small' smallMargin bold>
            <div style={{width: '360px'}}>
              <MultilineTextBox
                id='recipient-emails'
                name="reportSch-detail-recipient-emails"
                disabled={isView}
                style={{height: '80px'}}
                value={reportSch.recipientEmails}
                maxLength = {200}
                placeholder="email1@example.com; email2@example.com"
                onChange={e => onChange({recipientEmails: e.target.value})}
              />
            </div>
          </InlineInputControlRow>
          <InlineInputControlDoubleRow>&nbsp;</InlineInputControlDoubleRow>
            <InlineInputControlRow label='Shipment' mode='small' smallMargin bold>
            <div style={{display: 'flex', justifyContent:'space-between', width:'200px'}}>
              <div><RadioButton group="type" reverse label="O/I" disabled={isView}
                              checked={reportSch.shipmentType === 'OI'}
                              onChecked={() => {onChange({shipmentType: 'OI'})}}/></div>
              <div><RadioButton group="type" reverse label="O/E" disabled={isView}
                              checked={reportSch.shipmentType === 'OE'}
                        onChecked={() => {onChange({shipmentType: 'OE'})}}/></div>
              <div><RadioButton group="type" reverse label="O/T" disabled={isView}
                              checked={reportSch.shipmentType === 'OT'}
                    onChecked={() => {onChange({shipmentType: 'OT'})}}/></div>
            </div>
          </InlineInputControlRow>
          <InlineInputControlRow>&nbsp;</InlineInputControlRow>
            <InlineInputControlRow label='Email Template' mode='small' smallMargin bold>
              <div style={{width: '360px'}}>
                <EmailTemplateDropDown value={reportSch.templateName} reportType={'RSD'} disabled={isView} onChange={name => onChange({templateName: name??''})}/>
              </div>
            </InlineInputControlRow>
        </div>
        <div className="clearfix"/>

        <div style={{ padding: '20px 0 0 0' }}>
          <InlineInputControlRow label='Schedule' mode='xsmall' smallMargin bold></InlineInputControlRow>
          <hr style={{ border: '0px', height: '1px', backgroundColor: '#FF0000', marginTop: '3px', marginBottom: '15px' }} />
        </div>
          <div style={{marginLeft:'50px'}}>
            <InlineInputControlRow label='Frequency' mode='xxsmall' smallMargin bold>
                <div style={{width:'100px'}}>
                  <Select 
                    items={[
                      {label: 'Daily' , value: 1},
                      {label: 'Weekly', value: 2},
                      {label: 'Bi-Weekly', value: 3},
                      {label: 'Monthly', value: 4}
                    ]}
                    value={reportSch.frequency}
                     onChange={e => onChange({frequency:  Number(e.target.value)})}
                     disabled={isView}
                  />
                </div>
            </InlineInputControlRow>
        </div>
        <div style={{display: 'flex'}}>
          <div style={{marginLeft:'50px', marginRight:'60px'}}>
            <InlineInputControlRow label='Send Time' mode='xxsmall' id='send-time' smallMargin bold>
            <div style={{width: '50px'}}>
              {/* <input type="time" style={{ width: '100%', height: '19px' }} disabled={isView}   value={reportSch.sendTime ?? ''} onChange={e => onChange({sendTime: e.target.value ?? ''})}/> */}
                <Time value={reportSch.sendTime} onChange={(time) => onChange({ sendTime: time??'' })} noborderLeft={false} disabled={isView} />
              </div>
            </InlineInputControlRow>
          </div>
          <InlineInputControlRow label='Time Zone' mode='xxsmall' smallMargin bold>
                  <div style={{width:'290px'}}>
                  <Select 
                    items={[
                      { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "Pacific Standard Time" },
                      { label: "(UTC-06:00) Central Time (US & Canada)", value: "Central Standard Time" },
                      { label: "(UTC-06:00) Guadalajara, Mexico City, Monterrey", value: "Central Standard Time (Mexico)" },
                      { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "Eastern Standard Time" },
                      { label: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London", value: "GMT Standard Time" },
                      { label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "India Standard Time" },
                      { label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "China Standard Time" },
                      { label: "(UTC+08:00) Taipei", value: "Taipei Standard Time" },
                      { label: "(UTC+09:00) Seoul", value: "Korea Standard Time" },
                      { label: "(UTC+09:00) Osaka, Sapporo, Tokyo", value: "Tokyo Standard Time" },
                    ]}
                    value={reportSch.timeZone}
                    onChange={e => onChange({timeZone: e.target.value})}
                    disabled={isView}
                  />
                </div>
          </InlineInputControlRow>
        </div>
        <div style={{display: 'flex'}}>
          <div style={{marginLeft:'50px', marginRight:'30px'}}>
            <InlineInputControlRow label='Start Date' mode='xxsmall' smallMargin bold>
              <div style={{width: '80px'}}>
                <Date dateId="start-date" value={reportSch.startDate} 
                  disabled={isView || !isStartDateEditable} 
                  onChange={startDate => { 
                    onChange({startDate});
                  }}
                  onBlur={validStartDate}
                  onCalendarSelect={validStartDate}
                />
                </div>
            </InlineInputControlRow>
          </div>
          <InlineInputControlRow label='End Date' mode='xxsmall' smallMargin bold>
            <div style={{width: '80px'}}>
              <Date dateId="end-date" value={reportSch.endDate} 
                disabled={isView} 
                onChange={endDate => { 
                  onChange({endDate});
                }}
                onBlur={validEndDate}
                onCalendarSelect={validEndDate}
              />
              </div>
          </InlineInputControlRow>
        </div>
        <div  style={{marginLeft:'50px'}}>
          <InlineInputControlRow bold label='Remark' mode='xxsmall' smallMargin>
            <MultilineTextBox
              maxLength={200}
              style={{ height: '80px', width: '355px' }}
              textId='reportSch-memo'
              disabled={isView} 
              value={reportSch.remark}
              onChange={(e) => onChange({ remark: e.target.value })} />

          </InlineInputControlRow>
        </div>
        <InlineInputControlRow>&nbsp;</InlineInputControlRow>
        <div className = "clearfix"/>

        <div style={{justifyContent:'space-between', display:'flex'}}>
          <div style={{marginLeft:'50px'}}>
              <PrimaryButton size="small" onClick={()=>setShowColumnConfiguration(true)}>Report Columns</PrimaryButton>
          </div>
          <div style={{marginRight:'50px'}}>
            <CheckBox id="paused" label='Paused' bold value={reportSch.isPaused} onChange={isPaused => onChange({ isPaused})} disabled={isView} />
          </div>
        </div>
      </div>
      <IfmsModal isBlueHeader onCancel={()=> setShowColumnConfiguration(false)} columnOptionCloseOnEsc draggable isOpen={showColumnConfiguration} title="Column Option" width="380px">
        {showColumnConfiguration &&
          <ColumnSettings
            originalColumns={defaultColumn}
            currentColumns={settingColumn.columns}
            onCancel={() => setShowColumnConfiguration(false)}
            onSave={saveColumnsSettings}
            isLock={isView || appContext.user?.isSuntekAdmin}
          />
        }
      </IfmsModal>
      {exportLoadingMessage &&
        <Modal
          isOpen={exportLoadingMessage}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel=""
          style={{
            overlay: { ...ModalOverlayStyle, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
            content: ModalContentStyle,
          }}
        >
          <div style={{ display: 'flex', height: '150px', width: '350px', justifyContent: 'center', alignItems: 'center', fontSize: '18px', }}>
            <Spinner /> Please wait while processing…
          </div>
        </Modal>
      }
    </DocReportCard>
    
  );
}

export default React.memo(ReportSchedulingDetails);
